export enum UserType {
  private = 0,
  company = 1,
  businessRelation = 2,
}
